import { useEffect, useMemo, useState } from 'react';

const MOBILE_BREAKPOINT = 500;

export function useViewport() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const isMobile = useMemo(() => width < MOBILE_BREAKPOINT, [width]);
  const isDesktop = useMemo(() => width >= MOBILE_BREAKPOINT, [width]);

  return { width, isMobile, isDesktop };
}
